module.exports = __webpack_public_path__ + "img/15.b5c46d10.png";